import React from 'react'
import { components } from 'react-select'
import FlightAirportFieldListOption from './FlightAirportFieldListOption'

type Props = React.ComponentProps<typeof components.Option>

function FlightAirportFieldOption(props: Props) {
  const airport = props.data as App.AirportLocation

  return (
    <components.Option {...props}>
      <FlightAirportFieldListOption airport={airport}/>
    </components.Option>
  )
}

export default FlightAirportFieldOption
